/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { sharedListPagesFilterStyle } from "@monsma/App/WidgetExtensions/MyAccount/MyAccountListPagesExtension";
import { filterStyles } from "@monsma/Overrides/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { css } from "styled-components";

filterStyles.headingItem = {
    css: css`
        display: none;
    `,
};

filterStyles.container = sharedListPagesFilterStyle.container;

filterStyles.shipToGridItem = sharedListPagesFilterStyle.normalGridItem;

filterStyles.invoiceNumberGridItem = sharedListPagesFilterStyle.normalGridItem;

filterStyles.orderNumberGridItem = sharedListPagesFilterStyle.normalGridItem;

filterStyles.poNumberGridItem = sharedListPagesFilterStyle.normalGridItem;

filterStyles.fromGridItem = {
    width: [12, 6, 3, 2, 2],
    css: css`
        > div {
            width: 100%;
        }
    `,
};
filterStyles.toGridItem = {
    width: [12, 6, 3, 2, 2],
    css: css`
        > div {
            width: 100%;
        }
    `,
};

filterStyles.onlyOpenGridItem = {
    width: 12,
};
filterStyles.showCreditMemoOnly = {
    width: 12,
};

filterStyles.buttonsItem = sharedListPagesFilterStyle.buttonsItem;

filterStyles.clearFiltersButton = sharedListPagesFilterStyle.clearFiltersButton;
